// extracted by mini-css-extract-plugin
module.exports = {"cursor":"IconReviewUser_cursor__3eMct","root":"IconReviewUser_root__3nc5P"};